// frontend/src/data/zodiacInfo.js
export const SIGN_EMOJI = {
  aries: '♈', tauro: '♉', geminis: '♊', géminis: '♊', cancer: '♋', cáncer: '♋',
  leo: '♌', virgo: '♍', libra: '♎', escorpio: '♏', sagitario: '♐',
  capricornio: '♑', acuario: '♒', piscis: '♓',
};

function k(s) {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // sin tildes
}

export const ZODIAC_INFO = {
  aries: {
    nombre: 'Aries',
    emoji: '♈',
    fechas: '21 Mar – 19 Abr',
    elemento: 'Fuego',
    modalidad: 'Cardinal',
    regente: 'Marte',
    opuesto: 'Libra',
    compatibles: ['Leo', 'Sagitario', 'Géminis', 'Acuario'],
    fortalezas: ['Valiente', 'directo', 'enérgico', 'iniciador'],
    debilidades: ['Impulsivo', 'impaciente', 'competitivo'],
    descripcion:
      'Aries abre el zodíaco: liderazgo, impulso y acción. Ama los desafíos y odia la rutina. Su energía inspira y contagia.',
    leGusta: ['Competir', 'empezar proyectos', 'deporte', 'aventura'],
    noLeGusta: ['Esperar', 'ambigüedad', 'falta de decisiones'],
  },
  tauro: {
    nombre: 'Tauro',
    emoji: '♉',
    fechas: '20 Abr – 20 May',
    elemento: 'Tierra',
    modalidad: 'Fija',
    regente: 'Venus',
    opuesto: 'Escorpio',
    compatibles: ['Virgo', 'Capricornio', 'Cáncer', 'Piscis'],
    fortalezas: ['Constante', 'leal', 'práctico', 'sensual'],
    debilidades: ['Terco', 'posesivo', 'amante de la zona de confort'],
    descripcion:
      'Tauro ama lo estable y lo bello. Paciente y tenaz, construye a largo plazo y cuida lo que ama.',
    leGusta: ['Buen comer', 'arte', 'seguridad', 'naturaleza'],
    noLeGusta: ['Cambios abruptos', 'presión', 'improvisación excesiva'],
  },
  geminis: {
    nombre: 'Géminis',
    emoji: '♊',
    fechas: '21 May – 20 Jun',
    elemento: 'Aire',
    modalidad: 'Mutable',
    regente: 'Mercurio',
    opuesto: 'Sagitario',
    compatibles: ['Libra', 'Acuario', 'Aries', 'Leo'],
    fortalezas: ['Comunicativo', 'curioso', 'versátil', 'ingenioso'],
    debilidades: ['Disperso', 'nervioso', 'inconstante'],
    descripcion:
      'Géminis es la mente inquieta del zodíaco. Aprende rápido, conecta personas e ideas, y necesita variedad.',
    leGusta: ['Charlar', 'viajar', 'aprender', 'redes sociales'],
    noLeGusta: ['Rutina estricta', 'silencios incómodos', 'aburrimiento'],
  },
  cancer: {
    nombre: 'Cáncer',
    emoji: '♋',
    fechas: '21 Jun – 22 Jul',
    elemento: 'Agua',
    modalidad: 'Cardinal',
    regente: 'Luna',
    opuesto: 'Capricornio',
    compatibles: ['Escorpio', 'Piscis', 'Tauro', 'Virgo'],
    fortalezas: ['Empático', 'protector', 'intuitivo', 'familiar'],
    debilidades: ['Susceptible', 'nostálgico', 'cambiante'],
    descripcion:
      'Cáncer es corazón y hogar. Sensible y protector, necesita vínculos profundos y seguridad emocional.',
    leGusta: ['Hogar', 'familia', 'recuerdos', 'cocinar'],
    noLeGusta: ['Frialdad', 'críticas duras', 'inseguridad afectiva'],
  },
  leo: {
    nombre: 'Leo',
    emoji: '♌',
    fechas: '23 Jul – 22 Ago',
    elemento: 'Fuego',
    modalidad: 'Fija',
    regente: 'Sol',
    opuesto: 'Acuario',
    compatibles: ['Aries', 'Sagitario', 'Géminis', 'Libra'],
    fortalezas: ['Carismático', 'creativo', 'leal', 'lidera con pasión'],
    debilidades: ['Orgulloso', 'dramático', 'necesita atención'],
    descripcion:
      'Leo brilla. Expresivo y noble, busca dejar huella y compartir su calidez con el mundo.',
    leGusta: ['Arte', 'fiestas', 'romance', 'reconocimiento'],
    noLeGusta: ['Indiferencia', 'mediocridad', 'deslealtad'],
  },
  virgo: {
    nombre: 'Virgo',
    emoji: '♍',
    fechas: '23 Ago – 22 Sep',
    elemento: 'Tierra',
    modalidad: 'Mutable',
    regente: 'Mercurio',
    opuesto: 'Piscis',
    compatibles: ['Tauro', 'Capricornio', 'Cáncer', 'Escorpio'],
    fortalezas: ['Práctico', 'analítico', 'servicial', 'detallista'],
    debilidades: ['Crítico', 'perfeccionista', 'controlador'],
    descripcion:
      'Virgo optimiza. Observa, ordena y mejora procesos. Busca utilidad real y bienestar tangible.',
    leGusta: ['Hábitos sanos', 'organización', 'aprender', 'ayudar'],
    noLeGusta: ['Caos', 'improvisación eterna', 'desprolijidad'],
  },
  libra: {
    nombre: 'Libra',
    emoji: '♎',
    fechas: '23 Sep – 22 Oct',
    elemento: 'Aire',
    modalidad: 'Cardinal',
    regente: 'Venus',
    opuesto: 'Aries',
    compatibles: ['Géminis', 'Acuario', 'Leo', 'Sagitario'],
    fortalezas: ['Diplomático', 'armónico', 'social', 'estético'],
    debilidades: ['Indeciso', 'evita conflicto', 'dependiente'],
    descripcion:
      'Libra busca equilibrio y belleza. Conecta, negocia y construye puentes con estilo.',
    leGusta: ['Arte', 'pareja', 'justicia', 'armonía'],
    noLeGusta: ['Gritos', 'fealdad', 'injusticia', 'soledad prolongada'],
  },
  escorpio: {
    nombre: 'Escorpio',
    emoji: '♏',
    fechas: '23 Oct – 21 Nov',
    elemento: 'Agua',
    modalidad: 'Fija',
    regente: 'Marte/Plutón',
    opuesto: 'Tauro',
    compatibles: ['Cáncer', 'Piscis', 'Virgo', 'Capricornio'],
    fortalezas: ['Intenso', 'profundo', 'transformador', 'leal'],
    debilidades: ['Celoso', 'extremo', 'rencoroso'],
    descripcion:
      'Escorpio va al fondo. Pasión, transformación y verdad cruda. Nada de superficialidades.',
    leGusta: ['Misterios', 'intimidad', 'lealtad', 'psicología'],
    noLeGusta: ['Traición', 'mentiras', 'frivolidad'],
  },
  sagitario: {
    nombre: 'Sagitario',
    emoji: '♐',
    fechas: '22 Nov – 21 Dic',
    elemento: 'Fuego',
    modalidad: 'Mutable',
    regente: 'Júpiter',
    opuesto: 'Géminis',
    compatibles: ['Aries', 'Leo', 'Libra', 'Acuario'],
    fortalezas: ['Optimista', 'filosófico', 'aventurero', 'honesto'],
    debilidades: ['Impaciente', 'brusco', 'excesivo'],
    descripcion:
      'Sagitario explora. Busca sentido, expansión y experiencias que abran la mente.',
    leGusta: ['Viajes', 'libertad', 'debates', 'naturaleza'],
    noLeGusta: ['Rutina', 'límite estrecho', 'hipocresía'],
  },
  capricornio: {
    nombre: 'Capricornio',
    emoji: '♑',
    fechas: '22 Dic – 19 Ene',
    elemento: 'Tierra',
    modalidad: 'Cardinal',
    regente: 'Saturno',
    opuesto: 'Cáncer',
    compatibles: ['Tauro', 'Virgo', 'Escorpio', 'Piscis'],
    fortalezas: ['Disciplinado', 'responsable', 'estratégico', 'resiliente'],
    debilidades: ['Serio', 'duro consigo mismo', 'workaholic'],
    descripcion:
      'Capricornio construye. Ambición con método y paciencia para llegar lejos.',
    leGusta: ['Metas', 'estabilidad', 'mérito', 'orden'],
    noLeGusta: ['Desorden', 'improvisación crónica', 'promesas vacías'],
  },
  acuario: {
    nombre: 'Acuario',
    emoji: '♒',
    fechas: '20 Ene – 18 Feb',
    elemento: 'Aire',
    modalidad: 'Fija',
    regente: 'Saturno/Urano',
    opuesto: 'Leo',
    compatibles: ['Géminis', 'Libra', 'Aries', 'Sagitario'],
    fortalezas: ['Original', 'humanitario', 'visionario', 'independiente'],
    debilidades: ['Distante', 'rebelde por deporte', 'impredecible'],
    descripcion:
      'Acuario innova. Ideas disruptivas y mirada social. Le interesan las causas y el futuro.',
    leGusta: ['Tecnología', 'comunidad', 'libertad', 'novedad'],
    noLeGusta: ['Convencionalismo', 'drama', 'posesividad'],
  },
  piscis: {
    nombre: 'Piscis',
    emoji: '♓',
    fechas: '19 Feb – 20 Mar',
    elemento: 'Agua',
    modalidad: 'Mutable',
    regente: 'Júpiter/Neptuno',
    opuesto: 'Virgo',
    compatibles: ['Cáncer', 'Escorpio', 'Tauro', 'Capricornio'],
    fortalezas: ['Compasivo', 'artístico', 'místico', 'empático'],
    debilidades: ['Idealista', 'escapista', 'difícil de “aterrizar”'],
    descripcion:
      'Piscis siente el todo. Imaginación y sensibilidad espiritual, vocación de unir y sanar.',
    leGusta: ['Música', 'arte', 'ayudar', 'sueños'],
    noLeGusta: ['Crueldad', 'rigidez', 'realismo frío'],
  },
};

// helper: obtiene objeto por nombre de signo en cualquier formato
export function getSignInfo(sign) {
  if (!sign) return null;
  const key = k(sign);
  return ZODIAC_INFO[key] || null;
}